export const tr = {
    adaptive: 'Uyarlanabilir',
    filter: 'Filtre',
    'sizes-title': 'Boyutlar'
};
